// extracted by extract-css-chunks-webpack-plugin
module.exports = {"video_poster":"video_poster-20Y9MHCj"};